import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceContentsApplyConfirmModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: false
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.serviceContentsApplyConfirmModal.active,

      // model
      values: state => state.serviceContentsApplyConfirmModal.values
    }),
    ...mapGetters({
      getValue: 'serviceContentsApplyConfirmModal/getValue'
    }),
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      loadModel: 'serviceContentsApplyConfirmModal/loadModel',
      hide: 'serviceContentsApplyConfirmModal/hide'
    }),

    init () {
      this.loading = true

      // データ読出し
      this.loadModel()
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}